export function setBoolean(key: string, value: boolean) {
  localStorage.setItem(key, value ? 'true' : 'false');
}

export function getBoolean(key: string): boolean {
  return localStorage.getItem(key) === 'true';
}
